import { render, staticRenderFns } from "./ApprovalGateCard.vue?vue&type=template&id=140be00a&scoped=true"
import script from "./ApprovalGateCard.vue?vue&type=script&lang=js"
export * from "./ApprovalGateCard.vue?vue&type=script&lang=js"
import style0 from "./ApprovalGateCard.vue?vue&type=style&index=0&id=140be00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140be00a",
  null
  
)

export default component.exports